export default "__VITE_ASSET__0f432ed6__"